var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tooltip"},[_vm._t("default"),_c('span',{staticClass:"tooltiptext",class:_vm.position},[_vm._v(_vm._s(_vm.value))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }